import React, { useContext, useEffect, useState } from "react";
import { Field, reduxForm, getFormValues, InjectedFormProps } from "redux-form";
import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import "./styles.css";
import { Button } from "reactstrap";
import redFlag from "../../../images/red-flag.svg";
import cross from "../../../images/x.svg";

import { useParams } from "react-router-dom";

import Accordion from 'react-bootstrap/Accordion'
import { Card } from "react-bootstrap";
import writing from "../../../images/writing.svg"
import { Question } from "./Question";
import { TextField } from "common-fields";
import { OverallPercentage } from "../../../models/LeadModels";
import moment from "moment";
import MessageChatWindowFC from "../../MessageCenter/QuestionarieMC/MessageChatWindowFC";
import { normalizeTextarea } from "dynamic-questionarie";

interface QuestionnarieFormProps {
  formValues: any;
  currentQuestions: Array<Question>;
  disableFields: boolean;
  formInitialvalues: any;
  reviewValues: any;
  postsavequestion: any;
  formName: string;
  showMessageAndHistory:boolean;
}

const QuestionnaireReportForm: React.FC<QuestionnarieFormProps &
  InjectedFormProps<Record<string, unknown>, QuestionnarieFormProps>> = (props: any) => {
    // const service = new CustomerService();
    const { currentQuestions } = props;
    // console.log(currentQuestions);
    // const { clientId } = useParams();  
    const [complianceStatusData, setComplianceStatusData] = useState<OverallPercentage>()
    const [notesForm, setNotes] = useState<any[]>([]);


    useEffect(() => {
      // service
      //   .getComplianceOverallPercentage(clientId)
      //   .then((response: AxiosResponse<OverallPercentage>) => {
      //     setComplianceStatusData(response.data);
      //   });
    }, []);

    const setNotesFrame = (question: Question) => {
      if (complianceStatusData?.status !== "REVIEW_COMPLETED") {
        const notes = [...notesForm];
        if (!notesForm.includes(question.clientQuestionId)) {
          notes.push(question.clientQuestionId);
          setNotes(notes);
        }

      }
    };

    const closeFrame = (question: Question) => {
      const notes = [...notesForm];
      // notes = [];

      if (notesForm.includes(question.clientQuestionId)) {
        const id = notes.indexOf(question.clientQuestionId);
        notes.splice(id, 1);
      }
      else {
        //notes.push(question.clientQuestionId)
      }
      setNotes(notes);
    };

    const notesFrame = (question: Question) => {
      return (
        <Row>
          <Col md="10">
            <Row>
              <Col md="12">
                <span>Notes:</span>
              </Col>
              <Col className="editNotesArea">
                <Field
                  component={TextField}
                  name={"questionReview_" + question.clientQuestionId.toString()}
                  type="textarea"
                  normalize={normalizeTextarea}
                />
              </Col>
            </Row>
          </Col>
          <Col md="2 close">
            <Row>
              <Col md="12 cross">
                <img src={cross} onClick={() => closeFrame(question)} />
              </Col>
              <Col className="saveButton">
                <Button type="button">
                  Save
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      );
    };

    const layoutSet = (layoutCoulmns: number | null) => {
      if (layoutCoulmns) {
        return 4;
      }
      return 12;
    };


    const findGroupSearialNumbers = (complianceGroupId: any) => {
      const serialNumbers: Array<any> = [];
      currentQuestions.filter((m: Question) => m.complianceGroupId == complianceGroupId)
        .forEach((m: Question) => {
          if (serialNumbers.indexOf(m.serialNumber) == -1) {
            serialNumbers.push(m.serialNumber);
          }
        });
      return serialNumbers.sort();
    };

    const fillHeadertemplate = (question: Question, serialNumber: number) => {
      if (question.questionGroupHeaderTemplate) {
        if (question && question.questionGroupHeaderTemplate) {
          const regex = new RegExp("(?:{)([^}]*)(?:})", "g");
          // eslint-disable-next-line no-var
          var match, questionIds: Array<number> = [];
          while ((match = regex.exec(question.questionGroupHeaderTemplate)))
            questionIds.push(parseInt(match[1]));
          const questions = currentQuestions.filter((m: Question) => questionIds.indexOf(m.questionId) > -1
            && m.serialNumber == serialNumber);
          let template = question?.questionGroupHeaderTemplate;
          questions.forEach((m: Question) => {
            if (m.answers && m.answers?.length > 0) {
              if(m.questionType === "Percentage"){
                template =template.replace(`{${m.questionId}}`,m.answers[0].answer)
              }
              template = template.replace(
                `{${m.questionId}}`,
                (!(['Text'].includes(m.questionType)) && moment(m.answers[0].answer)?.isValid()) ? 
                  moment(m.answers[0].answer).format("MM/DD/yyyy") : 
                  m.answers[0].answer
              );
              
            } else {
              template = template.replace(
                `{${m.questionId}}`,
                "--"
              );
            }
          });
          template = template.replace('[', '<b>').replace(']', '</b>');
          return <div dangerouslySetInnerHTML={{ __html: template }} />;
        }
      }
      return "";
    };

    const renderQuestionField = (question: Question) => {
      return (
        <div className="d-flex1 dynoFields cdFormGroup">
          <div><label className="mb-0">{question.questionText}</label></div>
          <div><span className="answer-text">
            <b>{props.formValues["question_" + question.clientQuestionId]}</b></span></div>
        </div>
      );
    }
    const renderDependentQuestionGroup = (question: Question, serialNumber: number) => {
      return <React.Fragment>
        {question.dependentQuestionGroupHideHeading != true &&
          <h4 style={{ fontSize: question.dependentQuestionGroupHeadingSize + "px" }}
            className="CardInfoTitle">{question.denpendentQuestionGroupName}</h4>}
        <Row className="dependent-group-container nonAcoordion">
          {currentQuestions.filter((m: Question) =>
            m.denpendentQuestionGroupId == question.denpendentQuestionGroupId && m.serialNumber == serialNumber)
            .map((groupQuestion: Question, index: number) => {
              return <React.Fragment key={index}>
                <Col
                  key={groupQuestion.questionId}
                  sm="12"
                  className="DynoLayout"
                  md={layoutSet(groupQuestion?.layoutCoulmns)}>{renderQuestionField(groupQuestion)}
                </Col>
              </React.Fragment>
            })}</Row> </React.Fragment>;
    };
    const currentSerialNumberQuestion = (complianceGroupId: number, serialNumber: number) => {
      const data = currentQuestions.filter((m: Question) => m.complianceGroupId == complianceGroupId &&
        m.serialNumber == serialNumber);
      return data.length > 0 ? data[0] : null;
    }

    const renderRepetativeQuestionGroup = (question: Question) => {
      return <>
        {findGroupSearialNumbers(question.complianceGroupId).map((serial, index: number) => {
          const currentSerialQuestion = currentSerialNumberQuestion(question.complianceGroupId!, serial);
          return <div key={index} className="DynoColumns mb-4">
            <Row className={`field1 ${currentSerialQuestion.reviewFlagged ? "fieldFlag" : ""}`}>
              <Col md="12" className="formComponent">
                {question.reviewFlagged && <img src={redFlag} />}
                {question.reviewNotes && <img src={writing} />}
                {question.complianceGroupHideHeading != true &&
                  <h4 style={{ fontSize: question.complianceGroupHeadingSize + "px" }}
                    className="CardInfoTitle">{question.complianceGroupName}</h4>}

                <Row>
                  <div className="DynoColumns px-4">
                    <Accordion defaultActiveKey={serial.toString()}>
                      <Accordion.Item eventKey={serial.toString()}>
                        <Accordion.Header>
                          <Row>

                            <Col md="12" sm="12">
                            <div>{fillHeadertemplate(question, serial)}</div></Col>
                          </Row>
                        </Accordion.Header>
                        <Accordion.Body>
                          <Card.Body>
                            <Row>
                              {currentQuestions.
                                filter((m: Question) => m.complianceGroupId == question.complianceGroupId &&
                                  m.serialNumber == serial)
                                .map((groupQuestion: Question, indexNew: number) => {
                                  return <React.Fragment key={indexNew}>
                                    <Col
                                      key={groupQuestion.questionId}
                                      sm="12"
                                      className={groupQuestion.dependent ?
                                        "DynoLayout dependent-question" : "DynoLayout"}
                                      md={layoutSet(groupQuestion?.layoutCoulmns)}>
                                      {renderQuestionField(groupQuestion)}
                                    </Col>
                                  </React.Fragment>
                                })}
                            </Row>
                          </Card.Body>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                    <Row className="notesShow">
                      <div>{props.showMessageAndHistory ? "History" : ''}</div>
                      <div className="historyModel">
                        {currentQuestions.filter((m: Question) => m.complianceGroupId == question.complianceGroupId &&
                          m.serialNumber == serial).map((groupQuestion: Question, indexNew: number) => {
                            return (
                              <div key={indexNew}>
                                {props.showMessageAndHistory ? (groupQuestion !== undefined &&
                                  groupQuestion?.historyDTO[0]?.historyDTO.length < 0 === false ? (
                                  groupQuestion !== undefined &&
                                  groupQuestion?.historyDTO[0]?.historyDTO?.map((element: any, historyIndex: any) => (
                                    <Row className="infoPack" key={historyIndex}>
                                      <Col md="2" >{element.firstName}</Col>
                                      <Col md="1" className="">
                                        {moment(moment.utc(element.createdDate).toDate()).format('M/DD/YY')}</Col>
                                      <Col md="2" className="timeDate">
                                        {moment(moment.utc(element.createdDate).toDate()).format('hh:mm A')}</Col>
                                      <Col>{element.info}</Col>
                                    </Row>
                                  ))
                                ) : (
                                  <Row className="infoPack">
                                    <Col>No records found</Col>
                                  </Row>
                                )) : ''}
                              </div>

                            )
                          })}
                        {/* <div>{props.showMessageAndHistory ? "Messages" : ''}</div>
                        {currentQuestions.
                          filter((m: Question) => m.complianceGroupId == question.complianceGroupId &&
                            m.serialNumber == serial)?.map((groupQuestion: Question, indexNew: number) => {
                            return (
                              <div key={indexNew}>
                                {
                                  props.showMessageAndHistory ? (groupQuestion !== undefined &&
                                    groupQuestion?.contextDTO !== null && 
                                    groupQuestion?.contextDTO.length < 0 === false? (
                                    <MessageChatWindowFC
                                      messageThread={groupQuestion?.contextDTO}
                                      refreshCounter={0}
                                      summaryReport={true}
                                      clientDetails={props.clientDetails}
                                    />
                                  ) : "There are no messages available to display") : ''
                                }
                              </div>
                            )

                          })} */}

                      </div>

                    </Row>
                  </div>
                </Row>
              </Col>

            </Row>
            <>
              {!notesForm.includes(currentSerialQuestion?.clientQuestionId) ? (
                <>
                  {" "}
                  {currentSerialQuestion.reviewNotes && currentSerialQuestion.reviewNotes?.length > 0 ? (
                    <Row className="notesShow">
                      <div className="show">
                        <span className="head">Notes:</span> &nbsp;&nbsp;&nbsp;
                        <span className="content">{currentSerialQuestion.reviewNotes}</span>
                      </div>                

                    </Row>
                  ) : (
                    ""
                  )}
                </>
              ) : ""}
            </>


          </div>
        })}
      </>
    };
    const renderQuestionGroup = (question: Question) => {
      const dependentQuestionGroupIds: Array<number> = [];
      return <React.Fragment>
        <div className="DynoColumns">
          <Row className={`field1 ${question.reviewFlagged ? "fieldFlag" : ""}`}>
            <Col md="12" className="formComponent">
              {question.reviewFlagged && <img src={redFlag} />}
              {question.reviewNotes && <img src={writing} />}
              {question.complianceGroupHideHeading != true &&
                <h4 style={{ fontSize: question.complianceGroupHeadingSize + "px" }}
                  className="CardInfoTitle">{question.complianceGroupName}</h4>}

              <Row>
                <div className="DynoColumns px-4">
                  {findGroupSearialNumbers(question.complianceGroupId).map((serial, index: number) => {
                    return <Row key={index}>{currentQuestions.filter((m: Question) =>
                      m.complianceGroupId == question.complianceGroupId && m.serialNumber == serial)
                      .map((groupQuestion: Question) => {
                        if (groupQuestion.denpendentQuestionGroupId &&
                          dependentQuestionGroupIds.indexOf(groupQuestion.denpendentQuestionGroupId) > -1) {
                          return null;
                        }
                        if (groupQuestion.denpendentQuestionGroupId &&
                          dependentQuestionGroupIds.indexOf(groupQuestion.denpendentQuestionGroupId) == -1) {
                          dependentQuestionGroupIds.push(groupQuestion.denpendentQuestionGroupId);
                          return renderDependentQuestionGroup(groupQuestion, serial);
                        }
                        return <React.Fragment key={index}>
                          <Col
                            key={groupQuestion.questionId}
                            sm="12"
                            className={groupQuestion.dependent ? "DynoLayout dependent-question" : "DynoLayout"}
                            md={layoutSet(groupQuestion?.layoutCoulmns)}
                          >{renderQuestionField(groupQuestion)}
                          </Col>
                        </React.Fragment>
                      })}</Row>
                  })}
                </div>
              </Row>
            </Col>

          </Row>
        </div>
      </React.Fragment>
    };


    const renderQuestions = () => {
      const complianceGroupIds: Array<number> = [];
      const dependentQuestionGroupIds: Array<number> = [];
      return currentQuestions.map((question: Question) => {
        if (question.complianceGroupId &&
          complianceGroupIds.indexOf(question.complianceGroupId) > -1) {
          return null;
        }
        if (question.complianceGroupId &&
          complianceGroupIds.indexOf(question.complianceGroupId) == -1) {
          complianceGroupIds.push(question.complianceGroupId);
        }
        if (question.complianceGroupId == null) {
          if (question.denpendentQuestionGroupId &&
            dependentQuestionGroupIds.indexOf(question.denpendentQuestionGroupId) > -1) {
            return null;
          }
          if (question.denpendentQuestionGroupId &&
            dependentQuestionGroupIds.indexOf(question.denpendentQuestionGroupId) == -1) {
            dependentQuestionGroupIds.push(question.denpendentQuestionGroupId);
          }
        }
        return (
          <Col
            key={question.questionId}
            sm="12"
            className="DynoLayout"
            md={12}
          >
            {question.complianceGroupId && (
              <React.Fragment>
                {question.isRepetitive &&
                  <React.Fragment> {renderRepetativeQuestionGroup(question)}</React.Fragment>}
                {question.isRepetitive == false &&
                  <React.Fragment> {renderQuestionGroup(question)}</React.Fragment>}
              </React.Fragment>
            )}
            {question.complianceGroupId == null && question.denpendentQuestionGroupId && (
              <React.Fragment>
                {renderDependentQuestionGroup(question, 0)}
              </React.Fragment>
            )}
            {question.complianceGroupId == null && question.denpendentQuestionGroupId == null && (
              <Row className={`field1 ${question.reviewFlagged ? "fieldFlag" : ""}`}>
                <Col md="12" className="formComponent">
                  <React.Fragment>
                    <Col
                      key={question.questionId}
                      sm="12"
                      className={question.dependent ? "DynoLayout dependent-question" : "DynoLayout"}
                      md={layoutSet(question?.layoutCoulmns)}
                    >
                      {question.reviewFlagged && <img src={redFlag} />}
                      {question.reviewNotes && <img src={writing} />}
                      {renderQuestionField(question)}
                    </Col>
                  </React.Fragment>
                  <></>
                </Col>
              </Row>
            )}
            <>
              {question.isRepetitive == false ?
                <>{!notesForm.includes(question?.clientQuestionId) ? (
                  <>
                    {" "}
                    {question.reviewNotes && question.reviewNotes?.length > 0 ? (
                      <Row className="notesShow">
                        <div className="show">
                          <span className="head">Notes:</span> &nbsp;&nbsp;&nbsp;
                          <span className="content">{question.reviewNotes}</span>
                        </div></Row>) : ""}
                    <Row className="notesShow">
                      <div>{props.showMessageAndHistory ? "History" : ''}</div>
                      <div className="historyModel">
                        {props.showMessageAndHistory ? (question !== undefined &&
                          question?.historyDTO[0]?.historyDTO.length < 0 === false ? (
                          question !== undefined &&
                          question?.historyDTO[0]?.historyDTO?.map((element: any, historyIndex: any) => (
                            <Row className="infoPack" key={historyIndex}>
                              <Col md="2" >{element.firstName}</Col>
                              <Col md="1" className="">
                                {moment(moment.utc(element.createdDate).toDate()).format('M/DD/YY')}</Col>
                              <Col md="2" className="timeDate">
                                {moment(moment.utc(element.createdDate).toDate()).format('hh:mm A')}</Col>
                              <Col>{element.info}</Col>
                            </Row>
                          ))
                        ) : (
                          <Row className="infoPack">
                            <Col>No records found</Col>
                          </Row>
                        )) : ''}
                        <br />
                        <div>{props.showMessageAndHistory ? "Messages" : ''}</div>
                        {props.showMessageAndHistory ? (question !== undefined && question?.contextDTO !== null &&question?.contextDTO.length > 0  ? (
                          <MessageChatWindowFC
                            messageThread={question?.contextDTO}
                            refreshCounter={0}
                            summaryReport={true}
                            clientDetails={props.clientDetails}
                          />
                        ) : "There are no messages available to display") : ''}
                      </div>
                      
                    </Row>
                    <br />
                  </>
                ) : ""}</> : ''}
            </>
          </Col>
        );
      });
    };





    return (
      <>
        <form className="form-group">
          <Row>{renderQuestions()} </Row>
        </form>

      </>
    );
  };

export default connect((state: any, props: any) => {
  return {
    initialValues: { ...props.formInitialvalues, ...props.reviewValues },
    formValues: getFormValues(props.formName)(state),
    form: props.formName,
  };
})(
  reduxForm<Record<string, unknown>, QuestionnarieFormProps>({
    enableReinitialize: true,
  })(QuestionnaireReportForm)
);

